"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FONT_FAMILY_DEFAULTS = exports.MEDIA_BORDER_RADIUS_VAR = exports.BUTTON_BORDER_RADIUS_VAR = exports.TERTIARY_CTA_BORDER_VAR = exports.SECONDARY_CTA_BORDER_VAR = exports.PRIMARY_CTA_BORDER_VAR = exports.HEADER_BORDER_COLOR_VAR = exports.SUBTLE_PRIMARY_COLOR_VAR = exports.SUBTLE_BORDER_COLOR_VAR = exports.PRIMARY_ICON_COLOR_VAR = exports.SECONDARY_DISCOUNT_COLOR_VAR = exports.PRIMARY_DISCOUNT_COLOR_VAR = exports.TERTIARY_CTA_FILL_COLOR_VAR = exports.TERTIARY_CTA_TEXT_COLOR_VAR = exports.SECONDARY_CTA_FILL_COLOR_VAR = exports.SECONDARY_CTA_TEXT_COLOR_VAR = exports.PRIMARY_PAGE_TEXT_COLOR_VAR = exports.PRIMARY_PAGE_FILL_COLOR_VAR = exports.ACCENT_TEXT_COLOR_VAR = exports.ACCENT_FILL_COLOR_VAR = exports.PRIMARY_CTA_FILL_COLOR_VAR = exports.PRIMARY_CTA_TEXT_COLOR_VAR = exports.FONT_5_CSS_VAR = exports.FONT_4_CSS_VAR = exports.FONT_3_CSS_VAR = exports.SECONDARY_FONT_CSS_VAR = exports.PRIMARY_FONT_CSS_VAR = void 0;
exports.typographyCssVarName = typographyCssVarName;
exports.getTypographyCssVariableEntries = getTypographyCssVariableEntries;
exports.buildTypographyCssVariables = buildTypographyCssVariables;
exports.buildStorefrontCssVariables = buildStorefrontCssVariables;
exports.buildStorefrontCssDeclarations = buildStorefrontCssDeclarations;
const customization_1 = require("../api-types/customization");
const ctaBorder_1 = require("./ctaBorder");
exports.PRIMARY_FONT_CSS_VAR = '--primary-font';
exports.SECONDARY_FONT_CSS_VAR = '--secondary-font';
exports.FONT_3_CSS_VAR = '--font-3';
exports.FONT_4_CSS_VAR = '--font-4';
exports.FONT_5_CSS_VAR = '--font-5';
exports.PRIMARY_CTA_TEXT_COLOR_VAR = '--primary-cta-text-color';
exports.PRIMARY_CTA_FILL_COLOR_VAR = '--primary-cta-fill-color';
exports.ACCENT_FILL_COLOR_VAR = '--accent-fill-color';
exports.ACCENT_TEXT_COLOR_VAR = '--accent-text-color';
exports.PRIMARY_PAGE_FILL_COLOR_VAR = '--primary-page-fill-color';
exports.PRIMARY_PAGE_TEXT_COLOR_VAR = '--primary-page-text-color';
exports.SECONDARY_CTA_TEXT_COLOR_VAR = '--secondary-cta-text-color';
exports.SECONDARY_CTA_FILL_COLOR_VAR = '--secondary-cta-fill-color';
exports.TERTIARY_CTA_TEXT_COLOR_VAR = '--tertiary-cta-text-color';
exports.TERTIARY_CTA_FILL_COLOR_VAR = '--tertiary-cta-fill-color';
exports.PRIMARY_DISCOUNT_COLOR_VAR = '--primary-discount-color';
exports.SECONDARY_DISCOUNT_COLOR_VAR = '--secondary-discount-color';
exports.PRIMARY_ICON_COLOR_VAR = '--primary-icon-color';
exports.SUBTLE_BORDER_COLOR_VAR = '--subtle-border-color';
exports.SUBTLE_PRIMARY_COLOR_VAR = '--subtle-primary-color';
exports.HEADER_BORDER_COLOR_VAR = '--header-border-color';
exports.PRIMARY_CTA_BORDER_VAR = '--primary-cta-border';
exports.SECONDARY_CTA_BORDER_VAR = '--secondary-cta-border';
exports.TERTIARY_CTA_BORDER_VAR = '--tertiary-cta-border';
exports.BUTTON_BORDER_RADIUS_VAR = '--button-border-radius';
exports.MEDIA_BORDER_RADIUS_VAR = '--media-border-radius';
exports.FONT_FAMILY_DEFAULTS = '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif';
const TYPOGRAPHY_VAR_PREFIX = '--sf-typography';
/** The header hairline brands have always had; kept until a brand picks a border colour. */
const DEFAULT_HEADER_BORDER_COLOR = '#e5e7eb';
const TEXT_TRANSFORM_CSS_VALUES = {
    NONE: 'none',
    UPPERCASE: 'uppercase',
    LOWERCASE: 'lowercase',
    CAPITALIZE: 'capitalize',
};
const FONT_CSS_VAR_BY_SLOT = {
    primary: exports.PRIMARY_FONT_CSS_VAR,
    secondary: exports.SECONDARY_FONT_CSS_VAR,
    font3: exports.FONT_3_CSS_VAR,
    font4: exports.FONT_4_CSS_VAR,
    font5: exports.FONT_5_CSS_VAR,
};
function camelToKebab(value) {
    return value.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`);
}
/** `--sf-typography-<role>-<prop>`, the property a role-aware element reads. */
function typographyCssVarName(role, prop) {
    return `${TYPOGRAPHY_VAR_PREFIX}-${camelToKebab(role)}-${prop}`;
}
/**
 * The `--sf-typography-<role>-<prop>` entries for the brand's configured
 * typography role overrides — five per role, none when nothing is
 * configured so every role-aware element falls back to its own styling.
 */
function getTypographyCssVariableEntries(overrides) {
    const entries = [];
    for (const override of overrides) {
        const name = (prop) => typographyCssVarName(override.role, prop);
        entries.push([
            name('font-family'),
            `var(${FONT_CSS_VAR_BY_SLOT[customization_1.FONT_SLOT_BY_CHOICE[override.fontFamily]]})`,
        ]);
        entries.push([name('font-weight'), String(override.fontWeight)]);
        entries.push([name('line-height'), String(override.lineHeight)]);
        entries.push([
            name('text-transform'),
            TEXT_TRANSFORM_CSS_VALUES[override.textTransform],
        ]);
        entries.push([name('letter-spacing'), override.letterSpacing]);
    }
    return entries;
}
function buildTypographyCssVariables(overrides) {
    return getTypographyCssVariableEntries(overrides)
        .map(([name, value]) => `${name}: ${value};`)
        .join('\n');
}
function headerBorderColor(settings) {
    if (settings.headerBorderEnabled === false)
        return 'transparent';
    return settings.borderColorOverride || DEFAULT_HEADER_BORDER_COLOR;
}
/** Font slots 3–5 fall back to the primary font rather than to the system stack. */
function fontStackOrPrimary(family) {
    return family
        ? `"${family.name}", var(${exports.PRIMARY_FONT_CSS_VAR})`
        : `var(${exports.PRIMARY_FONT_CSS_VAR})`;
}
/**
 * Every custom property the storefront sets on `:root` for a brand, in the
 * order it has always emitted them. The single source for the storefront's
 * own `CSSVariableSetter` and for anything that renders brand HTML outside
 * the storefront — a section screenshot, say — so the two cannot drift.
 */
function buildStorefrontCssVariables(settings, enableShopperBrandSettings = customization_1.ENABLE_SHOPPER_BRAND_SETTINGS) {
    var _a, _b, _c;
    const pageTextColor = settings.primaryPageTextColor;
    const pageFillColor = settings.primaryPageFillColor;
    const tertiary = settings.tertiaryCtaTextColor && settings.tertiaryCtaFillColor
        ? {
            text: settings.tertiaryCtaTextColor,
            fill: settings.tertiaryCtaFillColor,
        }
        : null;
    const fonts = (0, customization_1.fontFamilyBySlot)(settings);
    const entries = [
        [
            exports.PRIMARY_FONT_CSS_VAR,
            `"${(_a = fonts.primary) === null || _a === void 0 ? void 0 : _a.name}", ${exports.FONT_FAMILY_DEFAULTS}`,
        ],
        [
            exports.SECONDARY_FONT_CSS_VAR,
            `"${(_b = fonts.secondary) === null || _b === void 0 ? void 0 : _b.name}", var(${exports.PRIMARY_FONT_CSS_VAR})`,
        ],
        [exports.FONT_3_CSS_VAR, fontStackOrPrimary(fonts.font3)],
        [exports.FONT_4_CSS_VAR, fontStackOrPrimary(fonts.font4)],
        [exports.FONT_5_CSS_VAR, fontStackOrPrimary(fonts.font5)],
        [exports.PRIMARY_PAGE_TEXT_COLOR_VAR, pageTextColor],
        [exports.PRIMARY_PAGE_FILL_COLOR_VAR, pageFillColor],
        [exports.PRIMARY_CTA_TEXT_COLOR_VAR, settings.primaryCtaTextColor],
        [exports.PRIMARY_CTA_FILL_COLOR_VAR, settings.primaryCtaFillColor],
        [exports.ACCENT_FILL_COLOR_VAR, settings.accentFillColor],
        [exports.ACCENT_TEXT_COLOR_VAR, settings.accentTextColor],
        [exports.SECONDARY_CTA_TEXT_COLOR_VAR, settings.secondaryCtaTextColor],
        [exports.SECONDARY_CTA_FILL_COLOR_VAR, settings.secondaryCtaFillColor],
        [exports.TERTIARY_CTA_TEXT_COLOR_VAR, tertiary === null || tertiary === void 0 ? void 0 : tertiary.text],
        [exports.TERTIARY_CTA_FILL_COLOR_VAR, tertiary === null || tertiary === void 0 ? void 0 : tertiary.fill],
        [exports.PRIMARY_DISCOUNT_COLOR_VAR, settings.primaryDiscountColor],
        [exports.SECONDARY_DISCOUNT_COLOR_VAR, settings.secondaryDiscountColor],
        [exports.PRIMARY_ICON_COLOR_VAR, settings.iconColorOverride || pageTextColor],
        [
            exports.SUBTLE_BORDER_COLOR_VAR,
            settings.borderColorOverride ||
                `color-mix(in srgb, ${pageTextColor} 10%, white 90%)`,
        ],
        [
            exports.SUBTLE_PRIMARY_COLOR_VAR,
            `color-mix(in srgb, ${pageTextColor} 40%, white 60%)`,
        ],
        [exports.HEADER_BORDER_COLOR_VAR, headerBorderColor(settings)],
        [
            exports.PRIMARY_CTA_BORDER_VAR,
            (0, ctaBorder_1.computeCtaBorder)(settings.primaryCtaFillColor, settings.primaryCtaTextColor, pageFillColor),
        ],
        [
            exports.SECONDARY_CTA_BORDER_VAR,
            (0, ctaBorder_1.computeCtaBorder)(settings.secondaryCtaFillColor, settings.secondaryCtaTextColor, pageFillColor),
        ],
        [
            exports.TERTIARY_CTA_BORDER_VAR,
            tertiary
                ? (0, ctaBorder_1.computeCtaBorder)(tertiary.fill, tertiary.text, pageFillColor)
                : null,
        ],
        [
            exports.BUTTON_BORDER_RADIUS_VAR,
            customization_1.BUTTON_BORDER_RADIUS_CSS[settings.buttonBorderRadiusStyle],
        ],
        ...(enableShopperBrandSettings
            ? [
                [
                    exports.MEDIA_BORDER_RADIUS_VAR,
                    customization_1.MEDIA_BORDER_RADIUS_CSS[(_c = settings.mediaBorderRadiusStyle) !== null && _c !== void 0 ? _c : 'ROUNDED'],
                ],
            ]
            : []),
        ...getTypographyCssVariableEntries(settings.typographyRoleOverrides),
    ];
    return entries.filter((entry) => Boolean(entry[1]));
}
/** The `:root { … }` block the storefront inlines server-side. */
function buildStorefrontCssDeclarations(settings, enableShopperBrandSettings = customization_1.ENABLE_SHOPPER_BRAND_SETTINGS) {
    const declarations = buildStorefrontCssVariables(settings, enableShopperBrandSettings)
        .map(([name, value]) => `${name}: ${value};`)
        .join('\n');
    return declarations ? `:root {\n${declarations}\n }` : '';
}
